import React, { useState, useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { history, rehydration } from 'store';
import Router from 'router';
import { ClearCacheProvider } from 'react-clear-cache';
import i18n from 'i18n';

const App: React.FC<Record<string, unknown>> = () => {
  const [state, setState] = useState<boolean>(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect((): void => {
    async function fetchData() {
      await rehydration();
      setState(true);
    }
    fetchData();
    document.title = i18n.t('AUTO_PANEL_TITLE_KEY');
  }, [setState]);

  return (
    <ClearCacheProvider duration={60000} auto>
      <ConnectedRouter history={history}>
        {state ? <Router /> : <div> {i18n.t('LOADING_KEY')}</div>}
      </ConnectedRouter>
    </ClearCacheProvider>
  );
};

export default App;
